import type { ErrorEntry } from "../types";

const MAX_ENTRIES = 50;
const buffer: ErrorEntry[] = [];

function push(entry: ErrorEntry) {
  buffer.push(entry);
  if (buffer.length > MAX_ENTRIES) buffer.splice(0, buffer.length - MAX_ENTRIES);
}

let installed = false;

export function startErrorCapture(): void {
  if (installed) return;
  installed = true;

  window.addEventListener("error", (event) => {
    push({
      message: event.message?.slice(0, 2048) ?? "Unknown error",
      stack: event.error?.stack?.slice(0, 8192),
      url: event.filename,
      line: event.lineno,
      column: event.colno,
      timestamp: Date.now(),
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    push({
      message: reason instanceof Error ? reason.message : String(reason).slice(0, 2048),
      stack: reason instanceof Error ? reason.stack?.slice(0, 8192) : undefined,
      timestamp: Date.now(),
    });
  });
}

export function snapshotErrors(): ErrorEntry[] {
  return buffer.slice();
}
